
import React, { Component } from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { Card, Fab, CardActions, CardContent, Divider, Button, Grid, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import clsx from 'clsx';

import { authMiddleWare } from '../util/auth';
import Languages from '../components/supportedLanguages';

import functionsApi from '../api';
import { getPaypalValue } from '../util/trainersHelper';

const styles = (theme) => ({
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	toolbar: theme.mixins.toolbar,
	root: {},
	details: {
		display: 'flex'
	},
	imageInput: {
		padding: '8px'
	},
	avatar: {
		height: 110,
		width: 100,
		flexShrink: 0,
		flexGrow: 0
	},
	locationText: {
		paddingLeft: '8px'
	},
	buttonProperty: {
		position: 'absolute',
		top: '50%'
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	progess: {
		position: 'absolute'
	},
	uploadButton: {
		marginLeft: '8px',
		margin: theme.spacing(1)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	submitButton: {
		marginTop: '10px'
	}
});

class account extends Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			email: '',
			phoneNumber: '',
			certification: '',
			country: '',
			profilePicture: '',
			paymentMethods: [],
			socialNetworks: [],
			contents: [],
			spokenLanguages: [],
			uiLoading: true,
			buttonLoading: false,
			imageError: ''
		};
	}

	componentWillMount = () => {
		authMiddleWare(this.props.history);
		functionsApi
			.get('/getTrainerDetail')
			.then((response) => {
				this.setState({
					name: response.data.userCredentials.name,
					email: response.data.userCredentials.email,
					certification: response.data.userCredentials.certification,
					phoneNumber: response.data.userCredentials.phoneNumber,
					country: response.data.userCredentials.country,
					id: response.data.userCredentials.id,
					socialNetworks: response.data.userCredentials.socialNetworks,
					paymentMethods: response.data.userCredentials.paymentMethods,
					contents: response.data.userCredentials.contents,
					spokenLanguages: response.data.userCredentials.spokenLanguages,
					uiLoading: false
				});
			})
			.catch((error) => {
				this.props.history.push('/login');
				this.setState({ errorMsg: 'Error in retrieving the data' });
			});
	};

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleInstagramChange = (event) => {
		this.setState({
			socialNetworks: [{ 'type': 'instagram', 'url': event.target.value }]
		});
	};

	handlePaypalChange = (event) => {
		this.setState({
			paymentMethods: [{ 'type': 'paypal', 'email': event.target.value }]
		});
	};

	handleLanguageChange = (event) => {

		const items = []

		for (const [index, value] of event.entries()) {
			if (typeof this.state.contents[index] === 'undefined') {
				items.push({ id: index, language: value.code, languageDescription: value.label, bio: value.bio })
			} else {
				var bio = this.state.contents[index].bio
				items.push({ id: index, language: value.code, languageDescription: value.label, bio: bio })
			}
		}

		this.setState({
			contents: items,
			spokenLanguages: event
		});
	};

	handleContentsChange = (event) => {
		var items = this.state.contents
		var item = items[event.target.id];

		item.bio = event.target.value
		items[event.target.id] = item

		this.setState({
			contents: items
		});
	};

	handleImageChange = (event) => {
		this.setState({
			image: event.target.files[0]
		});
	};

	profilePictureHandler = () => {
		if (typeof this.state.image === 'undefined') {
			return;
		};
		this.setState({
			uiLoading: true
		});
		authMiddleWare(this.props.history);
		let form_data = new FormData();
		form_data.append('image', this.state.image);
		form_data.append('content', this.state.content);
		
		functionsApi
			.post('/uploadProfilePhoto', form_data, {
				headers: {
					'content-type': 'multipart/form-data'
				}
			})
			.then(() => {
				window.location.reload();
			})
			.catch((error) => {				
				this.setState({
					uiLoading: false,
					imageError: 'Error in posting the data'
				});
			});
	};

	updateFormValues = (event) => {
		event.preventDefault();
		this.setState({ buttonLoading: true });
		authMiddleWare(this.props.history);

		this.profilePictureHandler()

		const formRequest = {
			name: this.state.name,
			socialNetworks: this.state.socialNetworks,
			paymentMethods: this.state.paymentMethods,
			contents: this.state.contents,
			spokenLanguages: this.state.spokenLanguages
		};

		functionsApi
			.post('/updateTrainerDetails', formRequest)
			.then(() => {
				this.setState({ buttonLoading: false });
			})
			.catch((error) => {
				this.props.history.push('/login');
				this.setState({
					buttonLoading: false
				});
			});
	};

	isContentEmpty() {
		var found = false;
		for (const [index, value] of this.state.contents.entries()) {
			if (!value.bio) {
				found = true;
			}
			break;
		}
		return found
	}

	render() {
		const { classes, ...rest } = this.props;
		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress className={classes.uiProgess} />}
				</main>
			);
		} else {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					<Card {...rest} className={clsx(classes.root, classes)}>
						<CardContent>
							<div className={classes.details}>
								<div>
									<Typography className={classes.locationText} gutterBottom variant="h4">
										{this.state.name}
									</Typography>

									<label htmlFor="image">
										<input
											style={{ display: 'none' }}
											id="image"
											name="image"
											type="file"
											onChange={this.handleImageChange}
										/>
										<div><span style={{ color: "red" }}>{this.state.imageError}</span></div>
										<Fab
											color="secondary"
											size="small"
											component="span"
											aria-label="add"
											variant="extended">
											<AddIcon /> Profile Picture
										</Fab>
										<div><span>{this.state.image && this.state.image.name}</span></div>
									</label>
								</div>
							</div>
							<div className={classes.progress} />
						</CardContent>
						<Divider />
					</Card>

					<br />
					<Card {...rest} className={clsx(classes.root, classes)}>
						<form autoComplete="off" noValidate>
							<Divider />
							<CardContent>
								<Grid container spacing={3}>
									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											label="User Id"
											margin="dense"
											name="userHandle"
											disabled={true}
											variant="outlined"
											value={this.state.id}
											onChange={this.handleChange}
										/>
									</Grid>
									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											label="Name"
											margin="dense"
											name="name"
											variant="outlined"
											value={this.state.name}
											onChange={this.handleChange}
										/>
									</Grid>
									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											label="Email"
											margin="dense"
											name="email"
											variant="outlined"
											disabled={true}
											value={this.state.email}
											onChange={this.handleChange}
										/>
									</Grid>
									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											label="Certification"
											margin="dense"
											name="email"
											variant="outlined"
											disabled={true}
											value={this.state.certification}
											onChange={this.handleChange}
										/>
									</Grid>
									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											label="Phone Number"
											margin="dense"
											name="phone"
											variant="outlined"
											disabled={true}
											value={this.state.phoneNumber}
											onChange={this.handleChange}
										/>
									</Grid>
									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											label="Country"
											margin="dense"
											name="country"
											disabled={true}
											variant="outlined"
											value={this.state.country}
											onChange={this.handleChange}
										/>
									</Grid>

									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											id="instagram"
											label="Instagram Profile Link"
											margin="dense"
											name="instagram"
											variant="outlined"
											value={this.state.socialNetworks[0].url}
											onChange={this.handleInstagramChange}
										/>
									</Grid>

									<Grid item md={6} xs={12}>
										<TextField
											fullWidth
											id="paypal"
											label="Paypal account"
											margin="dense"
											name="paypal"
											variant="outlined"
											value={getPaypalValue(this.state)}
											onChange={this.handlePaypalChange}
										/>
									</Grid>

									<Grid item xs={12}>
										<Languages
											variant="outlined"
											required
											fullWidth
											id="languages"
											label="Select the languages you speak"
											name="languages"
											autoComplete="languages"
											items={this.state.spokenLanguages}
											onChange={this.handleLanguageChange}
										/>
									</Grid>

									{this.state.contents.map((contents, i) => (
										<Grid item xs={12} key={i}>
											<TextField
												variant="outlined"
												required
												fullWidth
												name={contents.language}
												multiline
												rows={4}
												label={contents.languageDescription + ' bio'}
												type="contents"
												id={contents.id}
												autoComplete="contents"
												value={contents.bio}
												onChange={this.handleContentsChange}
											/>
										</Grid>
									))}

								</Grid>
							</CardContent>
							<CardActions />
						</form>
					</Card>
					<Button
						color="primary"
						variant="contained"
						type="submit"
						className={classes.submitButton}
						onClick={this.updateFormValues}
						disabled={
							this.state.buttonLoading ||
							!this.state.name ||
							(!this.state.socialNetworks || this.state.socialNetworks.length <= 0) ||
							(!this.state.spokenLanguages || this.state.spokenLanguages.length <= 0) ||
							(!this.state.contents || this.state.contents.length <= 0) ||

							this.isContentEmpty()
						}
					>
						Save details
						{this.state.buttonLoading && <CircularProgress size={30} className={classes.progess} />}
					</Button>
				</main>
			);
		}
	}
}

export default withStyles(styles)(account);